import { Business as BusinessIcon } from '@mui/icons-material';
import {
	Avatar,
	CircularProgress,
	Stack,
	SvgIcon,
	SvgIconTypeMap,
	Typography,
} from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

import i18n from '~lib/i18n';

// TODO: part of theme?
const color = '#304FFE';

interface LoadingFallbackProps {
	title?: string;
	icon?: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
	description?: string;
	hideProgress?: boolean;
}

/**
 * A loading component to show as a fallback
 */
const LoadingFallback = ({
	title = i18n.t('loading'),
	hideProgress = false,
	...props
}: LoadingFallbackProps) => {
	return (
		<Stack sx={{ justifyContent: 'center', height: 1 }}>
			<Stack spacing={2} alignItems='center'>
				{props.icon != null && (
					<Avatar
						sx={{
							color: color,
							bgcolor: '#E4EEFB',
							width: '91px',
							height: '91px',
						}}
					>
						<SvgIcon component={props.icon} sx={{ fontSize: '55px' }} />
					</Avatar>
				)}
				<Typography variant='h4'>{title}</Typography>
				<Typography>{props.description}</Typography>
				{!hideProgress && <CircularProgress sx={{ color: color }} />}
			</Stack>
		</Stack>
	);
};

export default LoadingFallback;
